export const getDateFormatDDMMAAAA = (dateToFormat: string) => {
  const date = new Date(dateToFormat);
  return `${date.getDate()}-${date.getMonth()+1}-${date.getFullYear()}`;
};

export const getFilterFormat = (date: Date | null) => {
  if (date === null) return null;
  else return `${date.getDate()}-${date.getMonth()+1}-${date.getFullYear()}`;
};

export const getStateBetweenDates = (startDate: string, endDate: string) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  const date = new Date();
  if (date > start && date < end) return "Vigente";
  else return "No Vigente";
};

export const getDashboardLastUpdate = () =>{  
  return new Date().toLocaleString();
}

